export const LINE_HEIGHT = 1.4;
export const VIEW_FONT_SIZE_DEFAULT = 13;
export const EDIT_FONT_SIZE_DEFAULT = 15;
